import React, { PureComponent } from 'react';
// import { withLocalize } from 'react-localize-redux';
import './style.scss';
import { connect } from 'react-redux';
import MatchSchedule from './match-schedule/index';
import LineChart from './chart/index';
import Batter from './batter/index';
import Pitcher from './pitcher/index';
import Appointment from './appointment/index';

class TeamReport extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const param = this.props.match.params.id;
        return (
            <div className="block-content">
                <MatchSchedule id={param} history={this.props.history}/>
                <LineChart id={param} teamName={this.props.teamName}/>
                <Batter id={param} history={this.props.history}/>
                <Pitcher id={param} history={this.props.history}/>
                <Appointment hideLoading={(i) => this.hideLoading(i)} id={param} history={this.props.history}/>
            </div>
        );
    }
}


const mapStateToProps = ({ teams }) => {
    return {
       
    };
}

const mapDispatchToProps = dispatch => {
    return {
        
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(TeamReport);